import state from '@/vuex-store/worker-adjustment/withhold-tax-report/state';
import mutations from '@/vuex-store/worker-adjustment/withhold-tax-report/mutations';
import getters from '@/vuex-store/worker-adjustment/withhold-tax-report/getters';
import actions from '@/vuex-store/worker-adjustment/withhold-tax-report/actions';
export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
